export default {
  COUPONS: "Coupons",
  COUPON: "Coupon",
  CREATECOUPONS: "Create Coupons",
};
